export function pickNeighborTag<T extends { key: string }>(
  tags: readonly T[],
  closedKey: string
): T | undefined {
  const index = tags.findIndex((tag) => tag.key === closedKey)
  if (index < 0) return undefined
  return tags[index + 1] ?? tags[index - 1]
}

export function canCloseTagsLeft<T extends { affix?: boolean }>(
  tags: readonly T[],
  index: number
): boolean {
  return index > 0 && tags.slice(0, index).some((tag) => !tag.affix)
}

export function canCloseTagsRight<T extends { affix?: boolean }>(
  tags: readonly T[],
  index: number
): boolean {
  return index >= 0 && tags.slice(index + 1).some((tag) => !tag.affix)
}

export function canCloseOtherTags<T extends { key: string; affix?: boolean }>(
  tags: readonly T[],
  key: string
): boolean {
  return tags.some((tag) => tag.key !== key && !tag.affix)
}

export function hasClosableTags<T extends { affix?: boolean }>(
  tags: readonly T[]
): boolean {
  return tags.some((tag) => !tag.affix)
}
